export const normalizeLeadStatus = (status) => {
  const normalized = String(status || "new")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

  switch (normalized) {
    case "follow_up":
    case "followup":
    case "contacted":
      return "new";
    case "approved":
      return "approved";
    case "synced":
      return "synced";
    case "archived":
    case "archive":
      return "archived";
    default:
      return "new";
  }
};

export const getLeadStatusLabel = (status) => {
  switch (normalizeLeadStatus(status)) {
    case "approved":
      return "Approved";
    case "contacted":
      return "New";
    case "synced":
      return "Synced";
    case "archived":
      return "Archived";
    default:
      return "New";
  }
};

export const getLeadStatusClass = (status) => `status status--${normalizeLeadStatus(status).replace(/_/g, "-")}`;

export const getSyncStatusLabel = (row) => (row?.last_synced_at ? "Synced" : "Not synced");
export const getSyncStatusValue = (row) => (row?.last_synced_at ? "synced" : "pending");
